import { useEffect, useRef } from 'react';
import { Button, Logo } from '@clear/ui';
import { useI18n } from '../i18n';
import { useSession } from '../session';

/**
 * Shown to everyone who signs in after the plant's access (trial) has ended. It cannot
 * be dismissed: no close button, Escape and the scrim do nothing, and the server refuses
 * every data request anyway. The only way out is Log out.
 */
export function TrialEnded() {
  const { t } = useI18n();
  const { logout } = useSession();
  const btn = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    btn.current?.focus();
    const keep = (e: KeyboardEvent) => {
      if (e.key === 'Escape') e.preventDefault();
    };
    window.addEventListener('keydown', keep);
    return () => window.removeEventListener('keydown', keep);
  }, []);

  return (
    <div className="trial">
      <div
        className="trial__card"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="trial-title"
        aria-describedby="trial-body"
      >
        <span className="trial__logo">
          <Logo size={30} />
        </span>
        <h1 id="trial-title" className="trial__title">
          {t('trial.title')}
        </h1>
        <p id="trial-body" className="trial__body">
          {t('trial.body')}
        </p>
        <Button ref={btn} variant="primary" size="lg" block icon="out" onClick={() => void logout()}>
          {t('trial.logout')}
        </Button>
      </div>
    </div>
  );
}
